import { render, staticRenderFns } from "./score-distribution-secret-items.vue?vue&type=template&id=3ac67f89&scoped=true"
import script from "./score-distribution-secret-items.vue?vue&type=script&lang=js"
export * from "./score-distribution-secret-items.vue?vue&type=script&lang=js"
import style0 from "./score-distribution-secret-items.vue?vue&type=style&index=0&id=3ac67f89&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac67f89",
  null
  
)

export default component.exports